export const replenishmentMockData = {
  replenishment_rate: {
    current: 28,
    trendWindow: 'P28D',
    trendData: [
      25, 26, 26, 27, 27, 28, 28, 29, 29, 30, 30, 29, 29, 28, 28, 27, 27, 26,
      26, 27, 27, 28, 28, 29, 29, 30, 29, 28,
    ],
    forecastHorizon: 'P7D',
    forecast: [29, 29, 30, 30, 31, 31, 32],
    trend: 'up',
    status: 'good',
    unit: 'replenishments/hr',
    label: 'Replenishment Rate',
    // Current variable values
    variableValues: {
      replenishmentType: 'all',
      priorityLevel: 'all',
      timeWindow: 'P28D',
    },
    // Related KPI data
    relatedData: {
      uph_picking: {
        correlation: 0.82,
        trend: 'up',
        current: 115,
        lag: 'PT30M',
      },
      picking_accuracy: {
        correlation: 0.51,
        trend: 'up',
        current: 99.6,
        lag: 'PT1H',
      },
      avg_distance_per_picklist: {
        correlation: 0.58,
        trend: 'down',
        current: 105,
        lag: 'PT30M',
      },
    },
    currentVisualization: 'line',
  },

  replenishment_picking_correlation: {
    current: 81,
    trendWindow: 'P28D',
    trendData: [
      77, 78, 78, 79, 79, 80, 80, 81, 81, 82, 82, 83, 83, 82, 82, 81, 81, 80,
      80, 79, 79, 80, 80, 81, 81, 82, 82, 81,
    ],
    forecastHorizon: 'P7D',
    forecast: [82, 82, 83, 83, 84, 84, 85],
    trend: 'up',
    status: 'good',
    unit: '%',
    label: 'Replenishment-Picking Correlation',
    // Current variable values
    variableValues: {
      lagTime: 'PT30M',
      correlationMethod: 'pearson',
      timeWindow: 'P28D',
    },
    // Time-of-day correlation data
    timeOfDayData: {
      '00:00-04:00': 75,
      '04:00-08:00': 78,
      '08:00-12:00': 85,
      '12:00-16:00': 83,
      '16:00-20:00': 80,
      '20:00-00:00': 76,
    },
    // Zone correlation data
    zoneData: {
      'Zone A': 84,
      'Zone B': 82,
      'Zone C': 78,
      'Zone D': 75,
      'Zone E': 86,
    },
    currentVisualization: 'heatmap',
  },

  // Stockout frequency KPI referenced by the correlation KPI
  stockout_frequency: {
    current: 4.2,
    trendWindow: 'P28D',
    trendData: [
      6.1, 6.0, 5.8, 5.6, 5.5, 5.3, 5.2, 5.0, 4.9, 4.8, 4.7, 4.6, 4.5, 4.4, 4.3,
      4.2, 4.1, 4.0, 4.0, 4.1, 4.2, 4.3, 4.4, 4.3, 4.2, 4.1, 4.1, 4.2,
    ],
    forecastHorizon: 'P7D',
    forecast: [4.1, 4.0, 3.9, 3.8, 3.7, 3.6, 3.5],
    trend: 'down',
    status: 'good',
    unit: '%',
    label: 'Stockout Frequency',
    // Current variable values
    variableValues: {
      timeWindow: 'P28D',
      itemCategory: 'all',
      locationGroup: 'all',
    },
    // Zone data
    zoneData: {
      'Zone A': 3.1,
      'Zone B': 3.5,
      'Zone C': 5.2,
      'Zone D': 5.8,
      'Zone E': 2.9,
    },
    // Time-of-day data
    timeOfDayData: {
      '00:00-04:00': 3.1,
      '04:00-08:00': 3.8,
      '08:00-12:00': 4.7,
      '12:00-16:00': 5.2,
      '16:00-20:00': 4.6,
      '20:00-00:00': 3.4,
    },
    currentVisualization: 'line',
  },

  // New mock data for average replenishment distance
  avg_replenishment_distance: {
    current: 68.5,
    trendWindow: 'P28D',
    trendData: [
      72.3, 71.9, 71.5, 71.0, 70.7, 70.3, 70.0, 69.8, 69.5, 69.3, 69.0, 68.8,
      68.7, 68.5, 68.3, 68.2, 68.0, 67.9, 67.8, 67.7, 67.6, 67.5, 67.4, 67.3,
      67.2, 67.1, 67.0, 66.9,
    ],
    forecastHorizon: 'P7D',
    forecast: [66.7, 66.5, 66.3, 66.0, 65.8, 65.5, 65.3],
    trend: 'down',
    status: 'good',
    unit: 'm',
    label: 'Average Replenishment Distance',
    // Current variable values
    variableValues: {
      replenishmentType: 'all',
      timeWindow: 'P28D',
    },
    // Zone data
    zoneData: {
      'Zone A': 58.2,
      'Zone B': 62.5,
      'Zone C': 72.8,
      'Zone D': 85.3,
      'Zone E': 63.7,
    },
    // Replenishment type data
    replenishmentTypeData: {
      reserve_to_pick: 75.3,
      bulk_to_case: 60.2,
      case_to_each: 45.8,
      external: 92.7,
    },
    currentVisualization: 'line',
  },

  // New mock data for average replenishment time
  avg_replenishment_time: {
    current: 4.8,
    trendWindow: 'P28D',
    trendData: [
      5.5, 5.4, 5.3, 5.3, 5.2, 5.2, 5.1, 5.1, 5.0, 5.0, 4.9, 4.9, 4.9, 4.8, 4.8,
      4.8, 4.7, 4.7, 4.7, 4.6, 4.6, 4.6, 4.5, 4.5, 4.5, 4.5, 4.4, 4.4,
    ],
    forecastHorizon: 'P7D',
    forecast: [4.3, 4.3, 4.2, 4.2, 4.1, 4.1, 4.0],
    trend: 'down',
    status: 'good',
    unit: 'min',
    label: 'Average Replenishment Time',
    // Current variable values
    variableValues: {
      replenishmentType: 'all',
      timeWindow: 'P28D',
    },
    // Zone data
    zoneData: {
      'Zone A': 4.2,
      'Zone B': 4.5,
      'Zone C': 5.1,
      'Zone D': 5.8,
      'Zone E': 4.4,
    },
    // Replenishment type data
    replenishmentTypeData: {
      reserve_to_pick: 5.3,
      bulk_to_case: 4.6,
      case_to_each: 3.9,
      external: 5.4,
    },
    currentVisualization: 'line',
  },

  // New mock data for minimum distance to pick location
  min_distance_to_pick_location: {
    current: 8.2,
    trendWindow: 'P28D',
    trendData: [
      12.0, 11.8, 11.5, 11.2, 10.9, 10.5, 10.2, 9.9, 9.6, 9.4, 9.2, 9.0, 8.9,
      8.8, 8.7, 8.6, 8.5, 8.4, 8.3, 8.3, 8.2, 8.2, 8.1, 8.1, 8.0, 8.0, 7.9, 7.9,
    ],
    forecastHorizon: 'P7D',
    forecast: [7.8, 7.7, 7.6, 7.5, 7.4, 7.3, 7.2],
    trend: 'down',
    status: 'good',
    unit: 'm',
    label: 'Min Distance to Pick Location',
    // Current variable values
    variableValues: {
      itemVelocity: 'all',
      timeWindow: 'P28D',
    },
    // Zone data
    zoneData: {
      'Zone A': 6.5,
      'Zone B': 7.2,
      'Zone C': 9.8,
      'Zone D': 12.1,
      'Zone E': 5.4,
    },
    // Item velocity data
    itemVelocityData: {
      a_fast: 5.8,
      b_medium: 8.7,
      c_slow: 10.1,
    },
    currentVisualization: 'bar',
  },

  // New mock data for maximum distance to pick location
  max_distance_to_pick_location: {
    current: 118.5,
    trendWindow: 'P28D',
    trendData: [
      135.0, 133.2, 131.5, 129.8, 128.2, 126.7, 125.2, 123.8, 122.4, 121.0,
      119.7, 118.4, 117.2, 116.0, 114.8, 113.7, 112.6, 111.5, 110.5, 110.0,
      109.5, 109.0, 108.5, 108.0, 107.6, 107.2, 106.8, 106.4,
    ],
    forecastHorizon: 'P7D',
    forecast: [106.0, 105.5, 105.0, 104.5, 104.0, 103.5, 103.0],
    trend: 'down',
    status: 'good',
    unit: 'm',
    label: 'Max Distance to Pick Location',
    // Current variable values
    variableValues: {
      itemVelocity: 'all',
      timeWindow: 'P28D',
    },
    // Zone data
    zoneData: {
      'Zone A': 92.7,
      'Zone B': 105.2,
      'Zone C': 128.5,
      'Zone D': 142.3,
      'Zone E': 124.0,
    },
    // Item velocity data
    itemVelocityData: {
      a_fast: 85.3,
      b_medium: 105.6,
      c_slow: 165.2,
    },
    currentVisualization: 'bar',
  },

  // New mock data for average distance to pick location
  avg_distance_to_pick_location: {
    current: 47.8,
    trendWindow: 'P28D',
    trendData: [
      58.5, 57.8, 57.1, 56.5, 55.8, 55.2, 54.5, 53.9, 53.3, 52.7, 52.1, 51.5,
      50.9, 50.4, 49.9, 49.3, 48.8, 48.4, 47.9, 47.5, 47.1, 46.8, 46.5, 46.2,
      45.9, 45.6, 45.3, 45.0,
    ],
    forecastHorizon: 'P7D',
    forecast: [44.7, 44.4, 44.1, 43.8, 43.5, 43.2, 42.9],
    trend: 'down',
    status: 'good',
    unit: 'm',
    label: 'Avg Distance to Pick Location',
    // Current variable values
    variableValues: {
      itemVelocity: 'all',
      timeWindow: 'P28D',
    },
    // Zone data
    zoneData: {
      'Zone A': 38.5,
      'Zone B': 42.1,
      'Zone C': 55.7,
      'Zone D': 62.3,
      'Zone E': 40.4,
    },
    // Item velocity data
    itemVelocityData: {
      a_fast: 32.4,
      b_medium: 48.7,
      c_slow: 62.3,
    },
    // Replenishment type data
    replenishmentTypeData: {
      reserve_to_pick: 52.5,
      bulk_to_case: 45.2,
      case_to_each: 38.7,
      external: 55.0,
    },
    currentVisualization: 'line',
  },

  // New mock data for replenishment jobs by workzone
  replenishment_jobs_by_workzone: {
    current: 48,
    trendWindow: 'P7D',
    trendData: [45, 47, 50, 52, 49, 46, 48],
    forecastHorizon: 'P7D',
    forecast: [50, 52, 55, 58, 54, 52, 50],
    trend: 'up',
    status: 'good',
    unit: 'jobs',
    label: 'Replenishment Jobs by Workzone',
    // Current variable values
    variableValues: {
      timeFrame: 'daily',
      replenishmentType: 'all',
      priorityLevel: 'all',
      timeWindow: 'P7D',
    },
    // Zone distribution data
    zoneData: {
      'Zone A': 58,
      'Zone B': 47,
      'Zone C': 42,
      'Zone D': 35,
      'Zone E': 62,
    },
    // Time frame distribution (hourly for a typical day)
    timeFrameData: {
      '00:00-04:00': 15,
      '04:00-08:00': 38,
      '08:00-12:00': 72,
      '12:00-16:00': 65,
      '16:00-20:00': 53,
      '20:00-00:00': 22,
    },
    // Priority level distribution
    priorityData: {
      critical: 12,
      high: 25,
      normal: 45,
      low: 18,
    },
    // Replenishment type distribution
    replenishmentTypeData: {
      reserve_to_pick: 52,
      bulk_to_case: 28,
      case_to_each: 15,
      external: 5,
    },
    // Heatmap data (workzones x time frames)
    heatmapData: [
      { zone: 'Zone A', timeFrame: '00:00-04:00', value: 8 },
      { zone: 'Zone A', timeFrame: '04:00-08:00', value: 12 },
      { zone: 'Zone A', timeFrame: '08:00-12:00', value: 18 },
      { zone: 'Zone A', timeFrame: '12:00-16:00', value: 15 },
      { zone: 'Zone A', timeFrame: '16:00-20:00', value: 10 },
      { zone: 'Zone A', timeFrame: '20:00-00:00', value: 5 },
      { zone: 'Zone B', timeFrame: '00:00-04:00', value: 5 },
      { zone: 'Zone B', timeFrame: '04:00-08:00', value: 8 },
      { zone: 'Zone B', timeFrame: '08:00-12:00', value: 15 },
      { zone: 'Zone B', timeFrame: '12:00-16:00', value: 12 },
      { zone: 'Zone B', timeFrame: '16:00-20:00', value: 8 },
      { zone: 'Zone B', timeFrame: '20:00-00:00', value: 3 },
      { zone: 'Zone C', timeFrame: '00:00-04:00', value: 2 },
      { zone: 'Zone C', timeFrame: '04:00-08:00', value: 7 },
      { zone: 'Zone C', timeFrame: '08:00-12:00', value: 12 },
      { zone: 'Zone C', timeFrame: '12:00-16:00', value: 10 },
      { zone: 'Zone C', timeFrame: '16:00-20:00', value: 8 },
      { zone: 'Zone C', timeFrame: '20:00-00:00', value: 3 },
      { zone: 'Zone D', timeFrame: '00:00-04:00', value: 0 },
      { zone: 'Zone D', timeFrame: '04:00-08:00', value: 5 },
      { zone: 'Zone D', timeFrame: '08:00-12:00', value: 10 },
      { zone: 'Zone D', timeFrame: '12:00-16:00', value: 12 },
      { zone: 'Zone D', timeFrame: '16:00-20:00', value: 8 },
      { zone: 'Zone D', timeFrame: '20:00-00:00', value: 0 },
      { zone: 'Zone E', timeFrame: '00:00-04:00', value: 0 },
      { zone: 'Zone E', timeFrame: '04:00-08:00', value: 10 },
      { zone: 'Zone E', timeFrame: '08:00-12:00', value: 17 },
      { zone: 'Zone E', timeFrame: '12:00-16:00', value: 16 },
      { zone: 'Zone E', timeFrame: '16:00-20:00', value: 15 },
      { zone: 'Zone E', timeFrame: '20:00-00:00', value: 4 },
    ],
    currentVisualization: 'heatmap',
  },
};

export default replenishmentMockData;
